<script lang="ts" context="module">
    export interface Locale {
        language: string;
    }
</script>

<script lang="ts">
    /*
        Use:
        <SeparatedList items={items} let:item>
            {item.title}
        </SeparatedList>
    */

    export let translateFn: (str: string, values?: object) => string;
    export let items: any[];
    export let customDelimiter: string | null = null;

    $: delimiter =
        customDelimiter ?? `${translateFn('FUSE.Common.ListDelimiter')} `;
</script>

{#each items as item, index}
    {@const isLastItem = items.length - 1 === index}
    <slot {item} {index} />{isLastItem ? '' : delimiter}
{/each}
